import type { FileRoutesByPath } from "@tanstack/react-router";

/**
 * Canonical SPA route paths for chat surfaces.
 *
 * Thread URLs always include the `/c/` segment under workspace chat
 * (`…/chat/$agentId/c/$threadId`). Prefer the helper below over inline `to:`
 * strings — RecentRow and other untyped Link wrappers accept `string` and will not
 * catch a missing `/c/`.
 *
 * `satisfies keyof FileRoutesByPath` fails typecheck if the route file is
 * renamed without updating this constant.
 */
export const CHAT_THREAD_ROUTE =
	"/$owner/chat/$agentId/c/$threadId" satisfies keyof FileRoutesByPath;

export function chatThreadLink(
	owner: string,
	agentId: string,
	threadId: string,
) {
	return {
		to: CHAT_THREAD_ROUTE,
		params: { owner, agentId, threadId },
	} as const;
}

/** Workspace Home (ops awareness) lives only at the org root. */
export function isOwnerHomePath(owner: string, pathname: string): boolean {
	const prefix = `/${owner}`;
	return pathname === prefix || pathname === `${prefix}/`;
}
